import React from "react";
import ReactTable from "react-table";
import useSearchHook from "hooks/useSearch.hook";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";

const CommonTable = ({
                       getListFunction,
                       list,
                       loading = false,
                       columns,
                       tableProps = {},
                       searchHookProps = {
                         size: 20,
                         sort: "id,asc"
                       },
                       FiltersComponent,
                       filterComponentProps
                     }) => {
  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getListFunction, searchHookProps);

  return (
    <div className="w-100 p-2">
      {FiltersComponent && (
        <div className="filters">
          <FiltersComponent
            activeFilters={filters}
            totalCount={list.total_count || 0}
            handleSearch={handleSearch}
            handleReset={handleReset}
            {...filterComponentProps}
          />
        </div>
      )}

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={columns}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        getNoDataProps={() => ({
          style: {
            zIndex: 0
          }
        })}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={list.total_pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        {...tableProps}
      />
    </div>
  );
};

export default CommonTable;



// WEBPACK FOOTER //
// ./src/views/lib/components/CommonTable/index.js